<template>
  <v-container>
    <div v-if="form.status=='SAGE_BLOCK'" class="popup-container">
      <div class="popup">
          <v-row>
            <v-col cols="11">
              <h2 style="flex: 1; text-align: center; padding-left: 90px;">Lo sentimos</h2>
            </v-col>
            <v-col cols="1" style="padding-top: 0px;">
              <button @click="closePopup" class="close-btn">
                <v-icon>mdi-close</v-icon>
              </button>
            </v-col>
          </v-row>
          <v-row>
            <p>Es necesario contactar con tu distribuidor de Sage50 para realizar el proceso de alta en Inmatic</p>
          </v-row>
      </div>
    </div>
    <v-row>
      <v-col class="form__user">
        <div
          :class="{
            'display-2': $vuetify.breakpoint.mdAndUp,
            'display-1': $vuetify.breakpoint.smAndDown,
          }"
          class="font-weight-bold mb-6"
        >
          Crear usuario
        </div>
        <v-form  v-model="valid" @submit.prevent="submit" class="form__create__user rounded-lg pa-2 mx-2 mb-8">
          <v-container>
            <v-row>
              <v-col cols="12" class="text-body-1 text-uppercase font-weight-bold violet--text">
                Datos fiscales
              </v-col> 
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  solo
                  v-model="form.business_name"
                  label="Razón social"
                  :rules="requiredRule"
                  :error="error_business_name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  solo
                  v-model="form.bussnies_id"
                  label="NIF / DNI"
                  maxlength="9"
                  :rules="requiredRule"
                  :error="error_bussnies_id"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  solo
                  v-model="form.email"
                  label="Email"
                  :rules="requiredRule"
                  :error="error_email"
                  :disabled=true
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  solo
                  v-model="form.phone"
                  label="Teléfono"
                  :rules="requiredRule"
                  :error="error_phone"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  solo
                  v-model="form.postal_address"
                  label="Dirección postal"
                  :rules="requiredRule"
                  :error="error_postal_address"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1">
                <v-text-field
                  solo
                  v-model="form.post_code"
                  label="CP"
                  :rules="requiredRule"
                  :error="error_post_code"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  solo
                  v-model="form.province"
                  label="Población"
                  :rules="requiredRule"
                  :error="error_province"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  solo
                  v-model="form.name"
                  label="Nombre / apellidos representante"
                  :rules="requiredRule"
                  :error="error_name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  solo
                  v-model="form.dni"
                  label="DNI representante"
                  maxlength="9"
                  :rules="requiredRule"
                  :error="error_dni"
                ></v-text-field>
              </v-col>
              <v-col cols="12" :md="program_value=='contasol_nube'?2:4">
                <v-select
                  class="capitalize"
                  :items="programas"
                  v-model="form.selected_program"
                  label="Programa contable"
                  :rules="requiredRule"
                  solo
                  item-text="name" 
                  item-value="id"
                  :error="error_selected_program"
                ></v-select>
              </v-col>
              <v-col v-if="program_value=='contasol_nube'" cols="12" md="2">
                <v-text-field
                  solo
                  v-model="customer_code"
                  label="Código de cliente"
                  maxlength="9"
                  :rules="requiredRule"
                  :error="error_customer_code"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-col cols="12" md="6">
                <v-select
                  :items="how_meet_us_items"
                  v-model="form.how_meet_us"
                  label="¿Cómo nos ha conocido?"
                  :rules="requiredRule"
                  solo
                  item-text="text" 
                  item-value="value"
                  :error="error_how_meet_us"
                ></v-select>
              </v-col>
            </v-row> -->
            <!-- <v-row>
              <v-col cols="12" md="4">
                <v-select
                  class="capitalize"
                  :items="programs"
                  v-model="form.program"
                  label="Programa contable"
                  :rules="requiredRule"
                  solo
                  item-text="name" 
                  item-value="value"
                ></v-select>
              </v-col>
            </v-row> -->            
         


            <v-row>
              <v-col cols="12">                                
                <v-checkbox
                  v-if="(!signupRules) || (signupRules && signupRules.signupRules)"
                  v-model="form.contract_accepted"
                  :rules="showTermsRule"
                >
                  <template v-slot:label>
                    <span  class="black--text">
                      He leído y acepto la
                      <PolicyDialogLink
                        name="Adhesión a la prestación de servicios"
                      >
                        <LegalContract 
                            :params="{
                              postal_address : form.postal_address,
                              province : form.province,
                              bussnies_id : form.bussnies_id,
                              business_name : form.business_name,
                              name : form.name,
                              docs_num : basic_contract_type?basic_contract_type.docs_num.toLocaleString('de-DE'):'',
                              price : basic_contract_type?basic_contract_type.price.toLocaleString('de-DE'):'',
                              date : date
                              }"
                            kind="contract"
                            @contract-data="getServiceContractData"
                          />                     
                      </PolicyDialogLink>
                    </span>
                  </template>
                </v-checkbox>

                <v-checkbox class="mt-0" 
                  v-model="form.policy_accepted"
                  :rules="showTermsRule"
                  v-if="(!signupRules) || (signupRules && signupRules.signupRules)"
                  >
                  <template v-slot:label>
                    <span class="black--text">
                      He leído y acepto la
                      <PolicyDialogLink name="Política de Privacidad">
                        <LegalContract 
                          :params="{
                            business_name : form.business_name,
                            name : form.name
                            }"
                          kind="data_treatment"
                          @contract-data="getDataTreatmentContractData"
                        />
                      </PolicyDialogLink>
                    </span>
                  </template>
                </v-checkbox>

                <v-checkbox class="mt-0" color="#66369B"
                  v-model="form.recieve_newsletter">
                  <template v-slot:label>
                    <span class="black--text">Deseo recibir novedades
                      <span v-if="!signupRules">
                        sobre Inmatic
                      </span>
                    </span>
                  </template>
                </v-checkbox>
                <p class="text-caption black--text">
                  Le informamos que los datos que voluntariamente nos
                  proporcione en el presente formulario serán tratados por
                  CONEPTUM S.L. con la finalidad de dar respuesta a la
                  solicitud. Sus datos no serán cedidos a tercero, salvo cuando
                  sea indispensable para la prestación del servicio u
                  obligaciones legales. Puede ejercer sus derechos de acceso,
                  rectificación, portabilidad, oposición y supresión de los
                  datos a través del correo admin@coneptum.com. Más información
                  en www.coneptum.com
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" offset-md="10" md="2">
                <v-btn
                  :disabled="!valid || submitting"
                  :loading="submitting"
                  block
                  type="submit"
                  color="secondary"
                >
                  Siguiente
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PolicyDialogLink from "./PolicyDialogLink";
import LegalContract from "./LegalContract";
import { user as api_user } from "@/api/user";
import { STATUS } from "../../store/modules/me";
import { connector as api_connector } from '@/api/connector'
import { mapFields } from 'vuex-map-fields';
import { excelFileChosen } from "@/modules/invoices/domain/Invoice";
import { GetDistributorCodeRules } from "@/modules/accounts/app/GetDistributorCodeRules"
import { query_dispatcher } from "@/api/client";
import validator from 'validator';



export default {
  name: "CreateUser",
  components: {
    PolicyDialogLink,        
    LegalContract,         
  },
  data() {
    return {
      valid: false,
      submitting: false,
      form: {
        business_name: "",
        bussnies_id: "",
        postal_address: "",
        post_code: "",
        province: "",
        name: "",
        dni: "",
        selected_program: "",
        // how_meet_us: "",
        terms_accepted: true,
        recieve_newsletter: false,
        status: STATUS.ACTIVE,
        email: "",
        phone: "",        
        contract_accepted: false,
        policy_accepted: false,
      },
      customer_code: "",
      programs: [
        {"name": "Contanet", "value": "contanet"},
        {"name": "Aplifisa", "value": "aplifisa"},
        // {"name": "Contasol", "value": "contasol"},
        // {"name": "A3", "value": "a3"},
        // {"name": "Monitor Informática", "value": "monitor"},
        // {"name": "NCS", "value": "ncs"},
        // {"name": "SAGE", "value": "sage"},
        // {"name": "Otro", "value": "other"},
      ],
      requiredRule: [(v) => Boolean(v) || "required"],

      crispMsg: "Creación de usuario",      
      date: '',
      months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      signupRules: null
    };
  },
  created() {
    this.setPrograms();
    this.setHowMeetUsItems();
    this.getContractTypes();
    this.fillForm();

    this.startCrispThread(this.crispMsg);
  },
  methods: {
    closePopup() {
      this.form.status = STATUS.ACTIVE;
    },
    async submit() {
      this.submitting = true;
      try {
        if (this.form.hasOwnProperty('customer_code')) {
          delete this.form['customer_code'];
        }
        if (this.program_value == 'contasol_nube') {
          this.form['customer_code'] = this.customer_code;
        } else if(this.program_value == 'sage_50'){
          this.form['status'] = STATUS.SAGE_BLOCK;
        }
        
        const response = await api_user.setUserInfo(this.form);
        this.setUserData(response.data.results);
        
        if(this.userData['status'] != STATUS.SAGE_BLOCK){
          await api_user.createLead({ 'state': 'signup2' });
        
          const response_cdb = await api_connector.create_default_cdb_training();
          const config_response = await api_connector.config_user_for_use_inmatic();        
          await api_user.updateWelcomeTrialContract();        
          await api_user.createLead({'state': 'trial'});
          this.endCrispThread(this.crispMsg);
          if (response_cdb.data.id) {
            await this.setCompanydbs();
            this.resetCurrentCompany({new_company: response_cdb.data});
            this.$router.push('/' + response_cdb.data.id + '/documents');
          } else {
            this.$router.push("/initial");
          }
        }
        
      } catch (error) {
        console.error(error);
      } finally {
        this.submitting = false;
      }
    },
    fillForm: function () {
      this.form.business_name = this.userData.business_name;
      this.form.bussnies_id = this.userData.bussnies_id;
      this.form.postal_address = this.userData.postal_address;
      this.form.post_code = this.userData.post_code;
      this.form.province = this.userData.province;
      this.form.name = this.userData.name;
      this.form.dni = this.userData.dni;
      this.form.selected_program = this.userData.selected_program;
      // this.form.how_meet_us = this.userData.how_meet_us;      
      this.form.recieve_newsletter = this.userData.recieve_newsletter;
      this.form.email = this.userData.email;
      this.form.phone = this.userData.phone;
      this.form.contract_accepted = this.userData.contract_accepted;
      this.form.policy_accepted = this.userData.policy_accepted;
    },
    ...mapActions({
      setUserData: "me/setUserData",
      setPrograms: "tutorial/setPrograms",
      setHowMeetUsItems: "tutorial/setHowMeetUsItems",
      startCrispThread: "me/startCrispThread",
      endCrispThread: "me/endCrispThread",
      setCompanydbs: 'setCompanydbs',
      resetCurrentCompany: 'resetCurrentCompany',
      getContractTypes: "contracts/getContractTypes",      
    }),
    getContractData: function (data) {
      this.form.privacy_policy_contract = data['full_version']
    },
    getServiceContractData: function (data) {
      this.form.service_contract = data['full_version']
    },
    getDataTreatmentContractData: function (data) {
      this.form.data_treatment_contract = data['full_version']
    }
  },
  computed: {
    ...mapGetters({
      userData: "me/userData",
      programas: "tutorial/programs",
      how_meet_us_items: "tutorial/how_meet_us_items",
    }),
    ...mapFields('contracts', ['contract_types']),
    basic_contract_type() {
      let ct = this.contract_types[0];      
      for (let i in this.contract_types) {
        if (this.contract_types[i].name == 'Basic') {
          ct = this.contract_types[i];
        }
      }
      return ct;
    },
    error_business_name(){
      return this.form.business_name && this.form.business_name.includes('@');
    },
    error_bussnies_id(){
      return this.form.bussnies_id && (this.form.bussnies_id.includes('@') || this.form.bussnies_id.length < 7);
    },
    error_postal_address(){
      return this.form.postal_address && this.form.postal_address.includes('@');
    },
    error_post_code(){
      let re = /(^\d{5}$)|(^\d{5}-\d{4}$)/
      return this.form.post_code && !re.test(this.form.post_code);
    },
    error_province(){
      return this.form.province && this.form.province.includes('@');
    },
    error_name(){
      return this.form.name && (this.form.name.includes('@') || this.form.name.length < 4);
    },
    error_dni(){
      return this.form.dni && (this.form.dni.includes('@') || this.form.dni.length < 7);
    },
    error_selected_program(){
      return false;
    },
    error_how_meet_us() {
      return false;
    },
    error_email(){
      return !validator.isEmail(this.form.email || '');
    },
    error_phone(){
      let re = /^(\+[0-9]{2})?[0-9]{9}$/
      return this.form.phone && !re.test(this.form.phone);
    },
    program_value() {
      let value = '';
      for (let i in this.programas) {
        if (this.programas[i]['id'] == this.form.selected_program) {
          value = this.programas[i]['value'];
        }
      }
      return value;
    },
    error_customer_code() {
      let error = false;
      if (this.program_value == 'contasol_nube' && this.customer_code == '') {
        error = true;
      }
      return error;
    },
    showTermsRule() {
      if (!this.signupRules || (this.signupRules && this.signupRules.show_terms)) {
        return [(v) => !!v || "Este campo es obligatorio"];
      }
      return []; // no aplica reglas si no se muestra
    },
  },
  watch: {
    userData: function () {
      this.fillForm();
    },
  },
  async mounted() {
    let now = new Date();
    let day = now.getDate();
    let year = now.getFullYear();
    let month = now.getMonth()
    this.date = day + ' de ' + this.months[month] + ' de ' + year;
    try {
      await new GetDistributorCodeRules(query_dispatcher, this).run();
    } catch (e) {
      console.error(e);
    }
  }
};
</script>

<style scoped>
.capitalize {
  text-transform: capitalize;
}
.form__create__user{
  background-color: #F2F1FF;
}
.violet--text {
  color:#66369B !important;
}
.black--text{
  color: black;
}
.theme--light.v-icon {
    color: #66369B !important;
}

.popup-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.popup {
  background: white;
  padding: 15px;
  width: 600px;

  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
  text-align: center;
  color: #66369B !important;
  z-index: 1001;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #66369B;
  cursor: pointer;
}

@media screen and (max-width: 960px) {

  .form__user {
    padding: 0 !important;
  }
  
}
</style>
